import './main.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { initTelemetry } from '@repo/features/telemetry';

import { pca } from './api.ts';
import { App } from './app.tsx';

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;
if (connectionString)
  initTelemetry({ connectionString, appName: 'cv-dashboard' });

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

// Completes a sign-in redirect before the first fetch, so it already has the account.
async function start() {
  await pca.initialize();
  const redirect = await pca.handleRedirectPromise();
  if (redirect?.account)
    pca.setActiveAccount(redirect.account);

  const rootElement = document.getElementById('root');
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </StrictMode>,
    );
  }
}

void start();
